import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Card from 'components/shared/card';
import styles from './styles.module.scss';

const TeacherCard = ({ teacher }) => (
  <Card>
    <div
      className={`${styles.teacherCard} d-flex flex-column align-items-center`}
    >
      <h3 className="font-heavy mb-2">{teacher.name}</h3>
      <img src={teacher.image} alt={`${teacher.name}'s portrait`} />
      <p className="text-center font-130 my-5">
        <FontAwesomeIcon
          className={styles.quoteLeft}
          icon="quote-left"
          size="2x"
        />
        {teacher.quote}
        <FontAwesomeIcon
          className={styles.quoteRight}
          icon="quote-right"
          size="2x"
        />
      </p>
    </div>
  </Card>
);

export default TeacherCard;
